// @mui
import { alpha, useTheme } from "@mui/material/styles";
import { Card, Typography, CardProps } from "@mui/material";
// utils
import { bgGradient } from "../../../fe-ui/utils/cssStyles";
// theme
import { ColorSchema } from "../../../fe-ui/theme/palette";
// components
import Iconify from "../../../fe-ui/atoms/Iconify/Iconify";

// ----------------------------------------------------------------------

interface Props extends CardProps {
  title: string;
  description?: string;
  icon: string;
  color?: ColorSchema;
}

export function AboutSummary({ title, description, children, icon, color = "primary", sx, ...other }: Props) {
  const theme = useTheme();

  return (
    <Card
      sx={{
        py: 5,
        px: 5,
        boxShadow: 0,
        textAlign: icon ? "center" : "left",
        color: theme.palette[color].darker,
        bgcolor: theme.palette[color].lighter,
        ...sx
      }}
      {...other}
    >
      <Iconify
        icon={icon}
        sx={{
          mb: 3,
          p: 2.5,
          width: 64,
          height: 64,
          borderRadius: "50%",
          color: theme.palette[color].dark,
          ...bgGradient({
            direction: "135deg",
            startColor: `${alpha(theme.palette[color].dark, 0)} 0%`,
            endColor: `${alpha(theme.palette[color].dark, 0.24)} 100%`
          })
        }}
      />

      <Typography variant="h5" sx={{ marginBottom: "10px", minHeight: icon ? "60px" : "auto" }}>
        {title}
      </Typography>

      {description ? <Typography sx={{ opacity: 0.64, minHeight: "72px" }}>{description}</Typography> : children}
    </Card>
  );
}
